// // Filter articles
// // TODO: Edit the articles here, when the sub graphs are clicked
// // the code below is just an outline
// export function filterArticles(id, allArticles){
//   if( !id ) {
//     const articles = allArticles;
//   } else {
//     const articles = allArticles[id];
//   }
//   return {
//     type: 'filterArticles',
//     articles: articles
//   };
// }
import { RECEIVE_ARTICLES } from "./constants.js";

// receive articles
export function receiveArticles(params) {
	const { articles, narrative, perspective, filtersList, currentFilters, fetchKey } = params;
	// console.log("receive ARTICLES - ", articles, narrative, perspective, filtersList, currentFilters);
	return (dispatch, getState) => {
		const { projectSpecificTagFormat } = getState().projectConfig;
		const { distractionFreeDeveloperMode } = getState().commonUI;
		dispatch({
			type: RECEIVE_ARTICLES,
			articles,
			narrative,
			perspective,
			filtersList,
			currentFilters,
			fetchKey,
			projectSpecificTagFormat,
			distractionFreeDeveloperMode,
		});
	};
}

export const fakeFunction = () => {
	return false;
};
